// FILE: src/components/LoginModules/TeacherLogin.js

import React, { useState } from 'react';
import {
    Dialog,
    DialogContent,
    Box,
    Typography,
    IconButton,
    Button,
    Divider,
    Paper,
    Checkbox,
    FormControlLabel,
    Link,
} from '@mui/material';
import { GoogleLogin } from "@react-oauth/google";
import MicrosoftIcon from "@mui/icons-material/Microsoft";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from 'react-router-dom';

import useGoogleLoginHandler from './hooks/useGoogleLoginHandler';
import useSimpleMicrosoftLogin from './hooks/useSimpleMicrosoftLogin';
import ModalPrivacy from '../../mainpagecomponents/Legal/ModalPrivacy';
import ModalTOS from '../../mainpagecomponents/Legal/ModalTOS';
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
    width: '90%',
    maxWidth: 600,
};

const TeacherLogin = ({ onLogin, onClose }) => {
    const [error, setError] = useState('');
    const [agreeAll, setAgreeAll] = useState(false);
    const [openTerms, setOpenTerms] = useState(false);
    const [openPrivacy, setOpenPrivacy] = useState(false);
    const navigate = useNavigate();

    const { handleGoogleSuccess, handleGoogleError } = useGoogleLoginHandler({ onLogin, onClose, setError });
    const { handleMicrosoftLogin, loading: microsoftLoading } = useSimpleMicrosoftLogin({ onLogin, onClose, setError });

    return (
        <>
            <Dialog open onClose={onClose} fullWidth maxWidth="xs">
                <DialogContent
                    sx={{
                        p: 0,
                        bgcolor: "background.default",
                        borderRadius: 3,
                        overflow: "hidden",
                        position: "relative",
                    }}
                >
                    <IconButton
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            top: 10,
                            right: 10,
                            zIndex: 1,
                            color: "primary.main",
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                    <Paper elevation={0} sx={{ p: 4, pt: 5, textAlign: "center", bgcolor: "transparent" }}>
                        <Typography variant="h5" fontWeight="bold" sx={{ mb: 1, color: "text.primary" }}>
                            Teacher Sign In
                        </Typography>

                        <Typography variant="body2" sx={{ color: "text.secondary", mb: 3 }}>
                            Access your Gradely dashboard
                        </Typography>

                        {error && (
                            <Typography color="error" sx={{ mb: 2 }}>
                                {error}
                            </Typography>
                        )}

                        <Box sx={{ textAlign: "left", mb: 2 }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={agreeAll}
                                        onChange={(e) => setAgreeAll(e.target.checked)}
                                        color="primary"
                                    />
                                }
                                label={
                                    <Typography variant="body2">
                                        I agree to the{' '}
                                        <Link component="button" onClick={() => setOpenTerms(true)}>
                                            Terms of Service
                                        </Link>{' '}
                                        and{' '}
                                        <Link component="button" onClick={() => setOpenPrivacy(true)}>
                                            Privacy Policy
                                        </Link>
                                    </Typography>
                                }
                            />
                        </Box>

                        <Box sx={{ display: "flex", justifyContent: "center", mb: 2, pointerEvents: agreeAll ? "auto" : "none", opacity: agreeAll ? 1 : 0.5 }}>
                            <GoogleLogin
                                onSuccess={handleGoogleSuccess}
                                onError={handleGoogleError}
                                useOneTap={false}
                            />
                        </Box>

                        <Divider sx={{ my: 2, color: "#ccc" }}>or</Divider>

                        <Button
                            variant="outlined"
                            fullWidth
                            startIcon={microsoftLoading ? null : <MicrosoftIcon />}
                            onClick={handleMicrosoftLogin}
                            color="primary"
                            disabled={!agreeAll || microsoftLoading}
                        >
                            {microsoftLoading ? "Redirecting..." : "Sign in with Microsoft"}
                        </Button>

                        <Typography variant="caption" sx={{ mt: 3, display: "block", color: "text.secondary" }}>
                            Only teachers can sign in. Students access reports only.
                        </Typography>
                    </Paper>
                </DialogContent>
            </Dialog>

            {/* Terms Modal */}
            <ModalTOS open={openTerms} onClose={() => setOpenTerms(false)}>
                <Box sx={modalStyle}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                        Terms of Service
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {/* Insert terms content here */}
                    </Typography>
                </Box>
            </ModalTOS>

            {/* Privacy Modal */}
            <ModalPrivacy open={openPrivacy} onClose={() => setOpenPrivacy(false)}>
                <Box sx={modalStyle}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                        Privacy Policy
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {/* Insert privacy content here */}
                    </Typography>
                </Box>
            </ModalPrivacy>
        </>
    );
};

export default TeacherLogin;
